module.exports = __webpack_public_path__ + "img/toplogo.eddd590d.png";